export const QueryKeys = {
  FxRate: 'fxRate',
  Currencies: 'currencies',
} as const

export type QueryKey = (typeof QueryKeys)[keyof typeof QueryKeys]
